export default __webpack_public_path__ + "static/media/Linkedin.df1d9f77.svg";